import { render, staticRenderFns } from "./IbLink.vue?vue&type=template&id=4916aca2&scoped=true"
import script from "./IbLink.vue?vue&type=script&lang=js"
export * from "./IbLink.vue?vue&type=script&lang=js"
import style0 from "./IbLink.vue?vue&type=style&index=0&id=4916aca2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4916aca2",
  null
  
)

export default component.exports